import React from "react";
import MainLayout from "./components/layouts/MainLayout";
export default function App(){
  return(
    <>
      <MainLayout/>
    </>
  );
}